import Tooltip from "@common/components/Tooltip/Tooltip";
import styled from "styled-components";

export const StyledTooltip = styled(Tooltip)`
  > span:first-child {
    z-index: 5;
  }
`;
